var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 1.375C6.23438 1.375 6 1.14062 6 0.8125C6 0.507812 6.23438 0.25 6.5625 0.25H9.9375C10.2422 0.25 10.5 0.507812 10.5 0.8125V4.1875C10.5 4.51562 10.2422 4.75 9.9375 4.75C9.60938 4.75 9.375 4.51562 9.375 4.1875V2.17188L4.6875 6.83594C4.47656 7.07031 4.125 7.07031 3.91406 6.83594C3.67969 6.625 3.67969 6.27344 3.91406 6.03906L8.57812 1.375H6.5625ZM0 2.3125C0 1.60938 0.585938 1 1.3125 1H3.9375C4.24219 1 4.5 1.25781 4.5 1.5625C4.5 1.89062 4.24219 2.125 3.9375 2.125H1.3125C1.19531 2.125 1.125 2.21875 1.125 2.3125V9.4375C1.125 9.55469 1.19531 9.625 1.3125 9.625H8.4375C8.53125 9.625 8.625 9.55469 8.625 9.4375V6.8125C8.625 6.50781 8.85938 6.25 9.1875 6.25C9.49219 6.25 9.75 6.50781 9.75 6.8125V9.4375C9.75 10.1641 9.14062 10.75 8.4375 10.75H1.3125C0.585938 10.75 0 10.1641 0 9.4375V2.3125Z",
    fill: "#1A2849"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink1);
export default __webpack_public_path__ + "static/media/external-link1.bc84edc9ecfa87282281c81b9024f4fb.svg";
export { ForwardRef as ReactComponent };